// iter167 Issue 23 — Single source of truth for which request statuses
// expose the Signatures tab + its content. Previously the parent
// RequestDetails.js (tab visibility + signature fetch) and the child
// SignaturesTab.jsx (content render guard) each maintained their own
// arrays and drifted out of sync, producing a "tab shown but content
// blank" bug whenever the request entered PENDING_CUSTOM_REVIEW or
// FT_PENDING_FINANCE on a CTA custom-review workflow.
//
// Anything that gates "should we expose / render the Signatures tab"
// MUST import from here. Do NOT inline a status list — drift will
// silently break the tab.

export const SIGNATURES_TAB_STATUSES_CTA = [
  'PENDING_DIRECTOR_REVIEW',
  'PENDING_EXEC_DIRECTOR_REVIEW',
  'FT_PENDING_FINANCE',
  'PENDING_CUSTOM_REVIEW',
  'PENDING_SIGNATURES',
  'READY_TO_EXECUTE',
  'EXECUTED',
];

export const SIGNATURES_TAB_STATUSES_FT = [
  'FT_PENDING_FINANCE',
  'FT_PENDING_DIRECTOR',
  'FT_PENDING_EXEC_DIR_REVIEW',
  'PENDING_CUSTOM_REVIEW',
  'PENDING_SIGNATURES',
  'READY_TO_EXECUTE',
  'EXECUTED',
];

export function isSignaturesTabStatus(type, status) {
  if (type === 'CTA') return SIGNATURES_TAB_STATUSES_CTA.includes(status);
  if (type === 'FT') return SIGNATURES_TAB_STATUSES_FT.includes(status);
  return false;
}
